import * as React from 'react';

const ChipIcon = () => (
  <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.5 26.5H17.5V4.5H29C29.1667 3.33333 28.5 0.8 24.5 0H11.5V26.5Z" fill="#E1E1E1"/>
    <path d="M3 0H9V4.5H0C0 3.33333 0.6 0.8 3 0Z" fill="#E1E1E1"/>
    <path d="M3 26H9V21.5H0C0 22.6667 0.6 25.2 3 26Z" fill="#E1E1E1"/>
    <path d="M26 26H20V21.5H29C29 22.6667 28.4 25.2 26 26Z" fill="#E1E1E1"/>
    <path d="M0 6.5H9V11.5H0V6.5Z" fill="#E1E1E1"/>
    <path d="M20 6.5H29V11.5H20V6.5Z" fill="#E1E1E1"/>
    <path d="M0 13.5H9V18.5H0V13.5Z" fill="#E1E1E1"/>
    <path d="M20 13.5H29V18.5H20V13.5Z" fill="#E1E1E1"/>
  </svg>
);

export default ChipIcon;
